import * as React from 'react'
import { TextField } from '@doordash/component-fields'
import { Text, InlineChildren } from '@doordash/design-language'
import { ProfileSetup as Tag } from '../../../../models/selectorAnchors'
import { HorizontalContainer } from './styles'
import t from '../strings'

type Props = {
  fields: { [k: string]: string }
  handleChange: (name: string, value: string) => void
}

export class JPNamesEntryForm extends React.Component<Props> {
  public static defaultProps = {
    fields: {
      firstName: '',
      lastName: '',
      altFirstName: '',
      altLastName: '',
    },
    handleChange: () => {},
  }

  render() {
    return (
      <React.Fragment>
        <Text size={Text.Sizes.S16} weight={Text.Weights.Bold}>
          {t.enterLegalName()}
        </Text>
        <HorizontalContainer
          size={InlineChildren.Sizes.XxSmall}
          alignItems={InlineChildren.Alignment.FlexStart}
        >
          <TextField
            label={t.lastName().concat('*')}
            onChange={value => this.props.handleChange('lastName', value)}
            autoComplete="family-name"
            data-anchor-id={Tag.LastName}
            {...this.props.fields.lastName}
          />
          <TextField
            label={t.firstName().concat('*')}
            onChange={value => this.props.handleChange('firstName', value)}
            autoComplete="given-name"
            data-anchor-id={Tag.FirstName}
            {...this.props.fields.firstName}
          />
        </HorizontalContainer>
        <Text size={Text.Sizes.S16} weight={Text.Weights.Bold}>
          {t.enterKanaName()}
        </Text>
        <HorizontalContainer
          size={InlineChildren.Sizes.XxSmall}
          alignItems={InlineChildren.Alignment.FlexStart}
        >
          <TextField
            label={t.lastName().concat('*')}
            onChange={value => this.props.handleChange('altLastName', value)}
            autoComplete="family-name-name"
            data-anchor-id={Tag.AltLastName}
            {...this.props.fields.altLastName}
          />
          <TextField
            label={t.firstName().concat('*')}
            onChange={value => this.props.handleChange('altFirstName', value)}
            autoComplete="given-name"
            data-anchor-id={Tag.AltFirstName}
            {...this.props.fields.altFirstName}
          />
        </HorizontalContainer>
      </React.Fragment>
    )
  }
}
